var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import Amplify, { Auth } from 'aws-amplify';
var defaultOptions = {
  isauthenticated: true,
  delay: 5000
};
export default (function (_ref) {
  var region = _ref.region,
      userPoolId = _ref.userPoolId,
      userPoolWebClientId = _ref.userPoolWebClientId;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions,
      _ref2$isauthenticated = _ref2.isauthenticated,
      isauthenticated = _ref2$isauthenticated === undefined ? defaultOptions.isauthenticated : _ref2$isauthenticated,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === undefined ? defaultOptions.delay : _ref2$delay;

  return function (WrappedComponent) {
    Amplify.configure({
      region: region,
      userPoolId: userPoolId,
      userPoolWebClientId: userPoolWebClientId
    });

    var CheckingAuthentication = function (_React$Component) {
      _inherits(CheckingAuthentication, _React$Component);

      function CheckingAuthentication(props) {
        _classCallCheck(this, CheckingAuthentication);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.state = {
          isauthenticated: isauthenticated
        };

        var getTokensAndSetState = function getTokensAndSetState() {
          return Auth.currentSession().then(function (session) {
            _this.setState({
              isauthenticated: session.isValid(),
              idToken: session.idToken.jwtToken,
              accessToken: session.accessToken.jwtToken
            });
          }).catch(function (error) {
            console.error(error);

            _this.setState({
              isauthenticated: false
            });
          });
        };

        getTokensAndSetState();
        _this.interval = setInterval(getTokensAndSetState, delay);
        return _this;
      }

      CheckingAuthentication.prototype.componentWillUnmount = function componentWillUnmount() {
        clearInterval(this.interval);
      };

      CheckingAuthentication.prototype.render = function render() {
        var _props = this.props,
            forwardedRef = _props.forwardedRef,
            otherProps = _objectWithoutProperties(_props, ['forwardedRef']);

        var _state = this.state,
            idToken = _state.idToken,
            accessToken = _state.accessToken,
            isauthenticated = _state.isauthenticated;
        return React.createElement(WrappedComponent, _extends({
          idToken: idToken,
          accessToken: accessToken,
          isauthenticated: isauthenticated,
          ref: forwardedRef
        }, otherProps));
      };

      return CheckingAuthentication;
    }(React.Component);

    var forwardRef = function forwardRef(props, ref) {
      return React.createElement(CheckingAuthentication, _extends({}, props, {
        forwardedRef: ref
      }));
    };

    return React.forwardRef(forwardRef);
  };
});